export default __webpack_public_path__ + "75699ca351ab68e66a8578e37792faf0.png";